import Skeleton from "@mui/material/Skeleton";
import * as React from "react";

export const JobsLoading = () => (
    <div>
        <div style={{ float: "left", textAlign: "right", width: "100%" }}>
            <Skeleton width="185px" height="50px" style={{ float: "right" }}/>
        </div>
        <div style={{ marginTop: "4em", float: "left", width: "100%" }}>
            <Skeleton width="56px" height="32px" style={{ marginBottom: "1em" }}/>

            <Skeleton height="78px" style={{ marginBottom: "0.8em" }}/>
            <Skeleton height="78px" style={{ marginBottom: "0.8em" }}/>
            <Skeleton height="78px" style={{ marginBottom: "0.8em" }}/>
            <Skeleton height="78px" style={{ marginBottom: "0.8em" }}/>
            <Skeleton height="78px" style={{ marginBottom: "0.8em" }}/>
        </div>
    </div>
)
